import { render, staticRenderFns } from "./NotificationAdd.vue?vue&type=template&id=719fc9d2&scoped=true&"
import script from "./NotificationAdd.vue?vue&type=script&lang=js&"
export * from "./NotificationAdd.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationAdd.vue?vue&type=style&index=1&id=719fc9d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719fc9d2",
  null
  
)

export default component.exports